var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isSubscribed)?_c('div',[_c('button',{attrs:{"aria-label":"unsubscribe"},on:{"click":_vm.cancelSubscription}},[_c('v-icon',[_vm._v(_vm._s("mdi-star"))])],1)]):_c('div',{attrs:{"top":""}},[_c('button',{attrs:{"aria-label":"subscribe"},on:{"click":_vm.subscribe}},[_c('v-icon',[_vm._v(_vm._s("mdi-star-outline"))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }